module.exports = __webpack_public_path__ + "static/media/21ECLAC38.a16e6080.jpg";